import { render, staticRenderFns } from "./TemplateFieldEditor.vue?vue&type=template&id=25b17fda&scoped=true&"
import script from "./TemplateFieldEditor.vue?vue&type=script&lang=ts&"
export * from "./TemplateFieldEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateFieldEditor.vue?vue&type=style&index=0&id=25b17fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b17fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
